import { render, staticRenderFns } from "./SalesList.vue?vue&type=template&id=ba2de568&"
import script from "./SalesList.vue?vue&type=script&lang=js&"
export * from "./SalesList.vue?vue&type=script&lang=js&"
import style0 from "./SalesList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports